// Helper: Fetch place details and extract coordinates

export const fetchPlaceLocation = async (placeId, sessionToken) => {
	const { Place } = window.google.maps.places;
	const place = new Place({ id: placeId });

	await place.fetchFields({
		fields: ['location'],
		sessionToken
	});

	if (!place.location) {
		throw new Error(
			'Error in finding coordinates for the selected location.'
		);
	}

	return {
		lat: place.location.lat(),
		lng: place.location.lng()
	};
};
